import { useEffect, useState } from "react";

// useState that survives in-app navigation (sessionStorage, per-tab).
export default function usePersistedState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(`tulsi:${key}`);
      if (raw !== null) return JSON.parse(raw);
    } catch {}
    return typeof initial === "function" ? initial() : initial;
  });
  useEffect(() => {
    try { sessionStorage.setItem(`tulsi:${key}`, JSON.stringify(value)); } catch {}
  }, [key, value]);
  return [value, setValue];
}
